module.exports = __webpack_public_path__ + "static/media/font.db1023cb.svg";